import React from 'react';
import styles from './ErrorAlert.module.scss';

const ErrorAlert = ({ title = 'Error', message, onRetry, retryLabel = 'Retry', className = '' }) => (
  <div className={`${styles.wrapper} ${className}`}>
    <div className="alert alert-danger">
      <h4 className={`alert-heading ${styles.heading}`}>{title}</h4>
      <p>{message}</p>
      {onRetry && (
        <button className={`btn btn-outline-danger ${styles.retryBtn}`} onClick={onRetry}>
          {retryLabel}
        </button>
      )}
    </div>
  </div>
);

export default ErrorAlert;
